import React, { Component } from 'react';
import { Link } from 'react-router';

import BandStore from "../../stores/BandStore";
import BandForm from "../../components/BandForm";

class BandDetails extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      band: {},
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handleBandSubmit = this.handleBandSubmit.bind(this);
  }

  componentWillMount() {
    BandStore.getBand(this.props.params.id, (band) => {
      this.setState({band: band});
    });
  }

  handleDelete() {
    if (confirm("Are you sure you want to delete this band?")) {
      BandStore.deleteBand(this.props.params.id, (responseData) => {
        this.context.router.push("/bands");
      });
    }
  }

  handleBandSubmit(band) {
    BandStore.updateBand(this.props.params.id, band, (responseData) => {
      this.context.router.push("/bands");
    });
  }

  render() {
    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/bands">Band</Link></li>
          <li className="active">{this.state.band.name}</li>
        </ol>
        <div className="clearfix">
          <div className="btn-group pull-right" role="group" aria-label="...">
            <button type="button" className="btn btn-danger" onClick={this.handleDelete}>delete</button>
          </div>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <BandForm band={this.state.band} onSubmit={this.handleBandSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default BandDetails;



// WEBPACK FOOTER //
// ./src/views/bands/BandDetails.js